var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-20-15"},[_c('el-button',{on:{"click":_vm.backup}},[_vm._v("备份数据库")]),_c('el-button',{on:{"click":_vm.selectFile}},[_vm._v("还原数据库")]),_c('el-button',{on:{"click":_vm.awakenApiAddress}},[_vm._v("配置API地址")]),_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.uploadFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }